import axios from "axios"
import { baseUrl } from "../../Config/baseUrl"

export const GetPaymentFeed = async(req) => {
    try { 
      const response = await axios.get(`${baseUrl}/blog/admin-payment-history/`, {
        params: req,
        headers: {
          Authorization:`Token ${localStorage.getItem("token")}`,
        },
      })
      return response
    }
    catch (err) {
      throw new Error(err)
    }
}





